<template>
    <div class="p-mypage__account p-mypage__account--password mypage-bloc">
    <div class="mypage-bloc__head">
        <h2>{{ $t("LABEL_PASSWORD_CONFIG") }}</h2>
    </div>
    <div class="mypage-bloc__content">
        <div class="password__setting">
        <p>{{ $t("TEXT_RESET_PASSWORD_EXPLANATION") }}</p>
        <div class="setting">
            <button id="btn-account-reminder" class="c-btn__account c-btn__account--reminder">{{ $t("TEXT_RESET_PASSWORD")
            }}</button>
        </div>
        </div>
    </div>
    </div>
</template>
<script setup>
</script>